const _import = require('../import-' + process.env.NODE_ENV)

const containerRouter = [
  {
    path: '/democracy/index',
    name: 'democracyIndex',
    component: _import('democracy/index'),
    meta: {
      title: '民主评议',
      auth: true
    }
  },
  {
    path: '/democracy/list',
    name: 'democracyList',
    component: _import('democracy/list'),
    meta: {
      title: '民主评议',
      auth: true
    }
  }
]
export default containerRouter



// WEBPACK FOOTER //
// ./src/router/work/democracy.js